import React, { PureComponent } from 'react'
import { func } from 'prop-types'
import { Text, Box, Flex } from '@chakra-ui/react'
import { getBodyContainer, getBrandSettings, isEmpty } from 'src/utils/helpers'
import SvgIcon from 'src/components/SvgIcon'
import { FormattedMessage } from 'react-intl'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon/index'

// import Modal from 'src/components/Modal'
// import Button from 'src/components/Button'

import Button from 'src/components/Button/Button'

import styles from './styles.module.less'
import Modal from 'src/components/Modal/Modal'

class ThankYou extends PureComponent {
  static propTypes = {
    onClose: func.isRequired,
    onSubmit: func.isRequired,
  }
  state = {
    isLoading: true,
    disclaimerMessage: null,
    afterHoursMessage: null,
    showAfterHours: this.props.isAfterHours,
  }

  componentDidMount() {
    this.loadCustomMessages()
  }

  /* componentDidUpdate(prevProps) {
    const { visible, onSubmit, afterHoursOnly } = this.props
    const { showAfterHours } = this.state

    if (prevProps.visible !== visible) {
      // Submit right away when checking only for "after hours" and it's not after hours
      if (afterHoursOnly === true && !showAfterHours && visible === true) {
        onSubmit()
      }
    }
  }*/

  loadCustomMessages = async () => {
    try {
      this.setState({
        isLoading: true,
      })

      const settings = await getBrandSettings('m')

      this.setState({
        disclaimerMessage: this.getMessageFromSettings(settings, 'disclaimerMessage'),
        afterHoursMessage: this.getMessageFromSettings(settings, 'afterHoursMessage'),
        isLoading: false,
      })
    } catch (e) {
      this.setState({
        isLoading: false,
      })
    }
  }

  getMessageFromSettings = (settings, messageName) => {
    try {
      // NOTE: PAT-3546 - For now only Claims disclaimer (when clicking on Report Claim option)
      // should get the custom message from backend. Later on remove the "showCustomMessage" prop
      // and replace it with some kind of "type" prop, so we know which custom message to show
      // (Claims, Add Driver, Remove Driver, Add Vehicle, Get Quote, etc...)
      const showCustomMessage =
        typeof this.props.showCustomMessage !== 'undefined' && this.props.showCustomMessage === true
      if (!showCustomMessage) {
        return null
      }

      if (
        settings &&
        settings.hasOwnProperty('messages') &&
        settings.messages &&
        settings.messages.hasOwnProperty(messageName) &&
        !isEmpty(settings.messages[messageName])
      ) {
        return settings.messages[messageName]
      }

      return null
    } catch (e) {
      return null
    }
  }

  closeModal = () => {
    // If it's after hours disclaimer, we should just hide it,
    // because props.onClose() would just hide both disclaimer types
    if (this.isAfterHoursPopup()) {
      this.hideAfterHours()
      return true
    }

    this.props.onClose()
  }

  submitModal = () => {
    this.props.onSubmit()
  }

  hideAfterHours = () => {
    this.setState({
      showAfterHours: false,
    })
  }

  isAfterHoursPopup = () => {
    const { skipAfterHoursCheck } = this.props
    const { afterHoursMessage, showAfterHours } = this.state
    return !!(afterHoursMessage && showAfterHours && skipAfterHoursCheck !== true)
  }

  renderThankYou = () => {
    const { renderContent, title } = this.props
    if (!renderContent) return

    return (
      <div style={{ textAlign: 'center' }}>
        <Flex direction={'column'} align={'center'} justify={'center'}>
          <Flex
            mb={'20px'}
            className={'kiosk--chakra-colors-modal-icon-container'}
            align={'center'}
            justify={'center'}
            w={'48px'}
            h={'48px'}
            borderRadius={'50%'}
          >
            <FontAwesomeIconComponent icon={['far', 'check']} size='sm' type='accent' />
          </Flex>
          <Box mb={'8px'}>
            <Text fontSize={'20px'} fontWeight={'bold'}>
              {title ? (
                title
              ) : (
                <FormattedMessage id='app.document.addDriver.thankYou' defaultMessage='Thank you' />
              )}
            </Text>
          </Box>
        </Flex>
        {renderContent}
        <Button isFullWidth mt={'24px'} onClick={this.closeModal}>
          <FormattedMessage id='app.global.close' defaultMessage='Close' />
        </Button>
      </div>
    )
  }

  render() {
    const { isWidget, visible } = this.props

    // NOTE: we can't show modal in widget mode
    // so we are gonna render content as full screen page
    if (isWidget) {
      if (!visible) {
        return ''
      }
      return (
        <div>
          <div className={styles.widgetModalBackdrop} onClick={this.closeModal} />
          <div className={styles.widgetModal}>
            <span onClick={this.closeModal} className={styles.closeWidgetModalIconHolder}>
              <SvgIcon type='RemoveThinner' className={styles.closeWidgetModalIcon} />
            </span>
            <div className={styles.widgetModalContent}>{this.renderThankYou()}</div>
          </div>
        </div>
      )
    }

    return (
      <Modal
        isOpen={visible}
        isCentered
        className={styles.pwaModal}
        closable={false}
        footer={null}
        onOk={this.submitModal}
        onClose={this.closeModal}
        renderContent={this.renderThankYou}
        getContainer={() => getBodyContainer()}
      ></Modal>
    )
  }
}

export default ThankYou
